import React from 'react'
import api, { METHODS } from './api'
import Report, { newReport } from '../common/types/api/report'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getReports(uid: string): Promise<Report> {
    try {
        const requestReport = await api<newReport>(`get/${uid}`, METHODS.GET)

        if (!requestReport.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to create a new report: ')}>{'unknown error'}</Notification>,
                20
            )
            console.error(requestReport)
        }

        return requestReport.config
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get Report: ')}>
                <tr>
                    <strong>Report id: </strong> {uid}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return null
    }
}
